import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AxiosPromise } from '../../../utils/axios.promise';
import { CommonConfig } from '../../../configs/config.common';
import * as moment from 'moment';
const base64 = require('base-64');

@Component
export default class VDeliveryAcceptancePage extends Vue {
    public data: string = '';
    public configs = new CommonConfig();
    public orderDetail = null;
    public disableBtn: any = null;
    public showFormPop = false;
    public message = '';
    public sid = null;
    public lock = false;
    public disableText = '';
    public priceTotal: any = '';
    public orderCreatedDate: any = null;
    public orderDeliveryDate: any = null;
    public async complain() {
        this.showFormPop = true;
    }
    public async closePop() {
        this.showFormPop = false;
    }
    public async complainSubmit() {
        if (this.lock) {
            return;
        }
        const userName = this.$route.query.userName;
        const email = this.$route.query.email;
        const phone = this.$route.query.phone;
        const vendorApi = this.configs.vendorService;
        this.lock = true;
        const sName = base64.decode(this.$route.params.receive);
        const fetched = await AxiosPromise.postJson(`${vendorApi}/customer/complain`, {
            saleOrderId: this.sid,
            details: `order: ${sName}{{comma}}name: ${userName}{{comma}}email: ${email}{{comma}}phone: ${phone}{{comma}}complain description: ${this.message}`
        });
        if (fetched.data && fetched.data.code === 200) {
            this.$Notice.success({
                desc: 'Our customer service representative will contact you',
                title: 'Successful Submit Complaint',
            });
            this.showFormPop = false;
            this.disableBtn = true;
            this.disableText = 'COMPLAIN PROCESSING';
        } else {
            this.$Notice.warning({
                desc: 'Request Failed',
                title: 'Error',
            });
        }
        this.lock = false;

    }
    public async accept() {
        try {
            const sName = base64.decode(this.$route.params.receive);
            const vendorApi = this.configs.vendorService;
            this.lock = true;
            const fetched = await AxiosPromise.postJson(`${vendorApi}/order/receive/confirm`, {
                sale_order_id: sName
            });
            if (fetched.status === 200 && fetched.data.code === 200) {
                this.$Notice.success({
                    desc: '',
                    title: 'Operation Succeed',
                });
                this.disableBtn = true;
                this.disableText = 'ACCEPTED';
            } else {
                this.$Notice.warning({
                    desc: 'Request Failed',
                    title: 'Error',
                });
            }
            this.lock = false;
        } catch (e) {
            this.$router.push('/not/found');
            this.lock = false;
        }
    }
    public async created() {
        const vendorApi = this.configs.vendorService;
        try {
            const sName = base64.decode(this.$route.params.receive);
            console.log(this.$route.params.receive);
            console.log(sName, 'sName');
            const url = `${vendorApi}/order/receive/detail?sale_order_id=${sName}`;
            const fetched = await AxiosPromise.get(url);
            if (fetched.code === 200) {
                const data = fetched.data;
                this.orderDetail = data;
                this.orderCreatedDate = moment.utc(data.create_date).add(12, 'hours').local().format('YYYY-MM-DD HH:mm');
                this.orderDeliveryDate = moment.utc(data.delivery_date).local().format('YYYY-MM-DD HH:mm');
                if (this.orderDetail) {
                    this.priceTotal = (this.orderDetail as any).product_line.reduce((acc: any, v: any) => {
                        acc += parseFloat(v.price_total);
                        return acc;
                    }, 0);
                }

                this.sid = data.id;
                this.disableBtn = data.order_state !== 'RECEIVE_PENDING';
                if (this.disableBtn) {
                    if (data.order_state === 'RECEIVE_COMPLAIN') {
                        this.disableText = 'COMPLAINT PROCESSING';
                    } else {
                        this.disableText = 'ACCEPTED';
                    }
                }
            }
        } catch (e) {
            this.$router.push('/not/found');
        }
    }

    public mounted() {
    }
}
